// extracted by mini-css-extract-plugin
export default {"prereq":"styles_prereq__Z1-KB","choices":"styles_choices__rEiI9"};